<template>
    <div class="x-tablelist-view" data-automation="manageProduct">
      <div class="search-warp">
              <ux-input v-model="filter.userName" :placeholder="$t('HT.rules.register.username')" ></ux-input>
                  <el-button type="primary"  @click="seach"  size="small">{{
                      $t('HT.search')
                  }}</el-button>
                  <el-button plain @click="reset" size="small" >{{
                      $t('HT.reset')
                  }}</el-button>
        </div>
  
  
      <!-- 表格 -->
      <div class="x-table-box">
        <ux-table ref="table" :showPage="showPage" maxHeight="100%" :hide-on-single-page="true" :data="tableData.list"
          :columns="columns" :total="tableData.totalSize" :size.sync="filter.size" :page.sync="filter.page"
          @changePage="changePage" @changeSize="changeSize" :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
  </template>
    
  <script lang="jsx">
  export default {
    data() {
      return {
        productList:[],
        serviceTypeList:[],
        userData: {}, // 登录者信息
        showPage: true,
        columns: [
          // 表头数据
          {
            label: this.$t('HT.user.id'),
            tooltip: true,
            align: 'left',
            prop: 'userId',
          },
          {
            label: this.$t('HT.advancedService.userAccount'),
            prop: 'userAccount',
            align: 'left',
            tooltip: true,
          },
          {
            label: this.$t('HT.advancedService.userName'),
            prop: 'userName',
            align: 'left',
            tooltip: true,
          },
          {
            label: this.$t('HT.advancedService.orderService'),
            align: 'left',
            tooltip: true,
            render:(h,data)=><div>{data.serverNames.join()}</div>
          },
          {
            label: this.$t('HT.advancedService.sourcePlatform'),
            prop: 'source',
            align: 'left',
            tooltip: true,
          },
  
          {
            label: this.$t('HT.voltageInfo.time'),
            prop: 'time',
            align: 'left',
            tooltip: true,
          },
          
          {
            label: this.$t('HT.operation'),
            hidden: !this.$hasModule(92),
            align: 'left',
            render: (h, params) => {
              return h('my-table-btn', {
                props: {
                  data: [
                    this.$t('HT.common.detail'),
                  ],
                  className: [
                    '',
                    this.userData.supervisor && params.published != 2 ? '' : 'no-click',
                    params.published == 0 ? 'no-click' : '',
                    ''
                  ],
                  event: ['goToDetail']
                },
                on: {
                  // 管理
                  goToDetail: () => {
                    this.goToDetail(params);
                  },
  
                }
              });
            }
          }
        ],
        filter: {
          // 查询参数
          userName:'',
          page: 1,
          size: 10
        },
        tableData: {
          // 表格数据
          totalSize: 0,
          list: []
        }
      };
    },
    created() {
      this.getAllList();
      this.userData = this.$store.state.login.userData;
    },
   
    methods: {
   
      /**
       * 获取列表
       * @param {Object} params 请求参数
       */
      getAllList() {
        const params = Object.assign({}, this.filter);
        this.$uxLoading.show();
        this.$api.advancedService.getUserList(params).then((res) => {
          if (res.code == 10000) {
            this.tableData = {
              totalSize: res.total_size,
              list: res.data
            };
          }
        });
      },
  
  
      /**
       * 搜索
       */
      seach() {
        this.filter.page = 1;
        this.getAllList();
      },
  
      /**
       * 改变页容量
       * @param {Number} size 选择的页容量
       */
      changeSize(size) {
        this.filter.size = size;
        this.filter.page = 1;
        this.getAllList();
      },
      /**
       * 改变页码
       * @param {Number} page 选择的页码
       */
      changePage(page) {
        this.filter.page = page;
        this.getAllList();
      },
      reset() {
        this.filter.userName = '';
        this.getAllList();
      },
      goToDetail(params) {
        this.$router.push({ path: '/advancedService/user/detail', query: { userId: params.userId,source:params.source } });
      },
    
    }
  };
  </script>
  <style lang="scss" scoped>
  .search-warp{
    display: flex;
    >div{
      width: auto !important;
      margin-right: 10px;
      display: inline-block;
    }
  }
  .ux-search-option{
        z-index: 10;
       }
  </style>